import Swiper from 'swiper';
import { Autoplay, A11y } from 'swiper/modules';

/**
 * AlertTicker — Alpine component for the promo banner.
 *
 * Only mounted when the banner holds more than one promo (see
 * app/Modules/Alert/templates/alert.twig, which renders a single promo as plain
 * markup and never reaches this file).
 *
 * ⚠ Autoplay is disabled outright when the visitor asks for reduced motion. The
 * bar sits under a sticky header and is on screen the whole time, so a promo
 * sliding past every five seconds is exactly the kind of persistent movement
 * that request is about. The slides are still there and still swipeable — only
 * the automatic advance goes away, which also removes the WCAG 2.2.2 problem of
 * moving content with no way to stop it.
 */
window.AlertTicker = () => ({
    swiper: null,

    init() {
        this.$nextTick(() => {
            const el = this.$el.querySelector('.alert-swiper');
            if (!el) return;

            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            this.swiper = new Swiper(el, {
                modules: [Autoplay, A11y],
                slidesPerView: 1,
                loop: true,
                speed: 600,
                autoHeight: true,
                autoplay: reduceMotion
                    ? false
                    : {
                        delay: 5000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    },
                a11y: {
                    containerRoleDescriptionMessage: 'Promotions',
                    itemRoleDescriptionMessage: 'Promotion',
                },
            });
        });
    },
});
